import { useSnapshotRoot } from '@/stores/root';
import Notfound from '@/components/notfound';
import type { PropsWithChildren } from 'react';
import { ESignType } from '@/enums/customer';
import { Loading } from '..';

interface IOnlyEnterpriseProps extends PropsWithChildren {}

const OnlyEnterprise = (props: IOnlyEnterpriseProps) => {
  const { children } = props;
  const { current, isLoading } = useSnapshotRoot();

  if (isLoading) return <Loading type="full" />;

  return current?.signType === ESignType.ENTERPRISE ? children : <Notfound />;
};

export default OnlyEnterprise;
